import React from "react";
import PageTemplate from "../../components/PageTemplate";
import SwitchMobileHeader from "../../components/Settings/SwitchMobileHeader";
import SwitchWorkspaceBody from "../../components/Settings/SwitchWorkspaceBody";

const SwitchWorkspace = () => {
  return (
    <PageTemplate
      title="Settings"
      mobileHeader={<SwitchMobileHeader />}
      sidebarTitle="Switch Workspace"
      sidebarSubtitle="Switch it up every once in a while..."
      centered
    >
      <SwitchWorkspaceBody />
    </PageTemplate>
  );
};

export default SwitchWorkspace;
